import { connect } from 'react-redux'

import {
  getProductList,
  setFilterValue,
  resetFilter,
} from 'reduxpath/ducks/Product/List'

import {
  resetSelection,
} from 'reduxpath/ducks/Reference'

import AddFilterSortProduct from 'utils/AddFilterSortProduct'
import FilterBox from './units'

const mapStateToProps = state => ({
  product: state.ProductList,
  filter: state.ProductList.filter,
  sort: state.ProductList.sort,
  searchProfileField: state.ProductList.searchProfileField,
  currentPage: state.ProductList.data.currentPage,

  param: {
    searchProfileField: state.ProductList.searchProfileField,
  },
})

const mapDispatchToProps = dispatch => ({
  setFilterValue(field, filter, sort) {
    return (event) => {
      const dataFilter = {
        ...filter,
      }

      if (field === 'searchKey') {
        dataFilter[field] = event.target.value
      } else if (field === 'isCreatedEndDateActive' || field === 'isUpdatedEndDateActive') {
        dataFilter[field] = event.target.checked
      } else {
        dataFilter[field] = event ? event.format('YYYY-MM-DD') : null
      }

      let qs = {
        sort: {
          isEligible: 'DESC',
          createdAt: 'DESC',
        },
        limit: 10,
        skip: 0,
        where: {
          isEligible: true,
        },
      }

      qs = AddFilterSortProduct(qs, dataFilter, sort)

      dispatch(setFilterValue(dataFilter))
      dispatch(getProductList(qs))
    }
  },

  resetFilter() {
    const qs = {
      sort: {
        isEligible: 'DESC',
        createdAt: 'DESC',
      },
      limit: 10,
      skip: 0,
      where: {
        isEligible: true,
      },
    }

    dispatch(getProductList(qs))
    dispatch(resetFilter())
    dispatch(resetSelection())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterBox)
